import React, { useState, useRef } from 'react';

interface StatusBarTooltipProps {
    label: string;
    value: number;
    percentage: number;
    flexGrow: number;
    children: React.ReactNode;
}

const StatusBarTooltip: React.FC<StatusBarTooltipProps> = ({
    label,
    value,
    percentage,
    flexGrow,
    children
}) => {
    const [isVisible, setIsVisible] = useState(false);
    const timeoutRef = useRef<NodeJS.Timeout | null>(null);

    const handleMouseEnter = () => {
        timeoutRef.current = setTimeout(() => {
            setIsVisible(true);
        }, 500);
    };

    const handleMouseLeave = () => {
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
            timeoutRef.current = null;
        }
        setIsVisible(false);
    };

    return (
        <div
            className="status-bar-tooltip-wrapper"
            style={{ flexGrow }}
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
        >
            {children}
            {isVisible && (
                <div className="status-bar-tooltip">
                    <div className="tooltip-label">{label}</div>
                    <div className="tooltip-stats">
                        <span className="tooltip-value">{value}</span>
                        <span className="tooltip-separator">•</span>
                        <span className="tooltip-percentage">
                            {(Math.floor(percentage * 10) / 10).toFixed(1)}%
                        </span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default StatusBarTooltip;
